import { useEffect, useMemo } from "react";
import usePollBackgroundEvent, {
  PollStatus,
} from "../../../hooks/usePollBackgroundEvent";
type PushToShopifyPollBridgeProps = {
  shopId: string | null;
  onStatusChange: (status: PollStatus) => void;
  enabled: boolean;
  pollKey: number;
};
export default function PushToShopifyPollBridge({
  shopId,
  onStatusChange,
  enabled,
  pollKey,
}: PushToShopifyPollBridgeProps) {
  const payload = useMemo(() => (shopId ? { shop_id: shopId } : {}), [shopId]);
  const pollStatus = usePollBackgroundEvent({
    path: "shopify-product-push",
    payload,
    enabled,
    pollKey,
  });
  useEffect(() => {
    onStatusChange(pollStatus);
  }, [pollStatus, onStatusChange]);
  return null;
}
